/*************************
 * @license
 * Copyright 2024 Myenergi Ltd. All rights reserved.
 * No part of this work may be reproduced, stored in a retrieval system of any nature, or transmitted, in any form or by any means without the prior written permission of Myenergi Ltd., the copyright owner.
 * If any unauthorised acts are carried out in relation to this copyright work, a civil claim for damages may be made and/or a criminal prosecution may result.
 *************************/
import { SerialNumber } from "@myenergi-ltd/static";
import { action, makeObservable, observable } from "mobx";
import { persist } from "mobx-persist";
import { DeviceName } from "models/graphql";
import { StoreBase } from "./StoreBase";

export class HubStore extends StoreBase {
  constructor() {
    super();
    makeObservable(this);
  }

  @observable @persist isEditing = false;
  @observable @persist isHubMonitored = false;
  @observable @persist selectedDeviceSerial: SerialNumber = -1 as SerialNumber;
  @observable @persist selectedDeviceName?: DeviceName;
  @observable @persist masterDeviceSerial?: SerialNumber;
  @observable @persist gridCTDeviceName?: DeviceName;

  @action.bound
  public setIsEditing(value: boolean) {
    this.isEditing = value;
  }

  @action.bound
  public setMasterDeviceSerial(serialNo: SerialNumber) {
    this.masterDeviceSerial = serialNo;
  }

  @action.bound
  public setSelectedDeviceSerial(serialNo: SerialNumber) {
    this.selectedDeviceSerial = serialNo;
  }

  @action.bound
  public isSelectedDeviceMaster() {
    if (this.selectedDeviceSerial && this.masterDeviceSerial) {
      return this.selectedDeviceSerial === this.masterDeviceSerial;
    }

    return false;
  }

  @action.bound
  public setGridCTDeviceName(deviceName?: DeviceName) {
    this.gridCTDeviceName = deviceName;
  }

  @action.bound
  public setSelectedDeviceName(deviceName: DeviceName) {
    this.selectedDeviceName = deviceName;
  }

  @action.bound
  public stopMonitoring() {
    this.isHubMonitored = false;
  }

  @action.bound
  public startMonitoring() {
    this.isHubMonitored = true;
  }
}

export default HubStore;
